import $ from "jquery";
import { compileTemplate } from "../../utils/handlebars-helper";

export const Overview = function () {
    if (!($(".overview-page").length > 0)) return false;

    const $elms = {
        page: $(".overview"),
        overviewPage: $(".overview-page"),
        sliderInput: $(".js-slider-input"),
        hotspot: $(".overview__hotspot"),
        goalPopup: $(".overview__goal"),
        goalContainer: $(".js-goal-container"),
        questionPopup: $(".overview__question"),
        questionContainer: $(".js-question-container"),
        questionClose: $(".overview__question__close"),
        questionSubmit: $(".js-submit-answers"),
        profile: $(".overview__profile"),
        profilePicture: $(".overview__profile__picture"),
        profileCardClose: $(".role-card__close"),
        continueBtn: $(".js-continue-to-next"),
        profileExpInner: $(".overview__profile__exp--inner"),
        progressCounter: $(".js-progress-counter"),
        completedCount: $(".js-completed-count"),
        totalCount: $(".js-total-count"),
    };

    let currentGoalId = null;
    let currentGoalData = null;
    // Goal the loaded details actually belong to, and the goal whose questions are
    // currently rendered. Answers must always be submitted against the rendered goal.
    let loadedGoalId = null;
    let renderedGoalId = null;
    let goalDetailsRequestId = 0;

    $(document).on("input", ".js-slider-input", function () {
        const $this = $(this);
        const questionId = $this.data("question-id");
        const value = parseInt($this.val(), 10);

        const $sliderFeedback = $this.closest(".slider").siblings(".slider__feedback");

        const feedbacks = resolveQuestionFeedback(questionId);
        if (!feedbacks || !feedbacks.feedback || !feedbacks.feedback.length) {
            $sliderFeedback.hide();
            return;
        }

        const feedback = feedbacks.feedback.find(
            (f) =>
                value >= parseInt(f.range_min, 10) &&
                value <= parseInt(f.range_max, 10)
        );

        if (feedback) {
            $sliderFeedback.text(feedback.feedback);
            $sliderFeedback.show();
        } else {
            $sliderFeedback.hide();
        }
    });

    function resolveQuestionFeedback(questionId) {
        if (currentGoalData && currentGoalData.questions) {
            const question = currentGoalData.questions.find((q) => q.ID === questionId || q.ID == questionId);
            if (question && question.feedback) {
                return { ID: questionId, feedback: question.feedback };
            }
        }
        if (currentGoalData && currentGoalData.question_feedback) {
            const found = currentGoalData.question_feedback.find(
                (item) => item.ID === questionId || item.ID == questionId
            );
            if (found) return found;
        }
        if (window.CFG && window.CFG.data && window.CFG.data.question_feedback) {
            return window.CFG.data.question_feedback.find(
                (item) => item.ID === questionId || item.ID == questionId
            );
        }
        return null;
    }

    $(document).on("touchstart", function () {
        if ($elms.page.hasClass("is-drag-overlay-open")) {
            $elms.page.removeClass("is-drag-overlay-open");
        }
    });

    function dismissDragOverlay(e) {
        if (!$elms.page.hasClass("is-drag-overlay-open")) return;
        $elms.page.removeClass("is-drag-overlay-open");
        if (e) {
            e.stopPropagation();
            if (e.pointerType === "mouse" || e.type === "click") {
                e.preventDefault();
            }
        }
    }

    function suppressNextClick() {
        const handler = function (e) {
            if ($elms.page[0] && $elms.page[0].contains(e.target)) {
                e.preventDefault();
                e.stopPropagation();
            }
            document.removeEventListener("click", handler, true);
        };
        document.addEventListener("click", handler, true);
        setTimeout(function () {
            document.removeEventListener("click", handler, true);
        }, 400);
    }

    $(document).on("click", ".overview__drag--overlay", function (e) {
        dismissDragOverlay(e);
    });

    const dragOverlayEl = document.querySelector(".overview__drag--overlay");
    if (dragOverlayEl) {
        dragOverlayEl.addEventListener("pointerdown", function (e) {
            dismissDragOverlay(e);
        }, { passive: false });
        dragOverlayEl.addEventListener("touchstart", function (e) {
            if ($elms.page.hasClass("is-drag-overlay-open")) {
                $elms.page.removeClass("is-drag-overlay-open");
                suppressNextClick();
                if (e.touches.length && initMapPanFromTouch(e.touches[0], e)) {
                    e.preventDefault();
                }
            }
        }, { passive: false });
    }

    // ----- Map pan (touch + pointer) for Safari -----
    const PAN_THRESHOLD = 5;
    let mapPan = {
        active: false,
        startX: 0,
        startScrollLeft: 0,
        touchId: null,
        pointerId: null,
        moveHandler: null,
        endHandler: null,
        rafId: null,
        pendingScrollLeft: null
    };

    function applyPanScroll(container) {
        if (container && mapPan.pendingScrollLeft != null) {
            const maxScroll = container.scrollWidth - container.clientWidth;
            container.scrollLeft = Math.max(0, Math.min(maxScroll, mapPan.pendingScrollLeft));
            mapPan.pendingScrollLeft = null;
        }
        mapPan.rafId = null;
    }

    function schedulePanScroll(container, scrollLeft) {
        mapPan.pendingScrollLeft = scrollLeft;
        if (mapPan.rafId == null) {
            mapPan.rafId = requestAnimationFrame(function () {
                applyPanScroll(container);
            });
        }
    }

    // function getMapPanClientX(e) {
    //     if (e.touches && e.touches.length) return e.touches[0].clientX;
    //     if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
    //     return e.clientX;
    // }

    function getMapPanTouchById(e, id) {
        const list = (e.touches && e.touches.length ? e.touches : null) || (e.changedTouches || []);
        for (let i = 0; i < list.length; i++) {
            if (list[i].identifier === id) return list[i];
        }
        return null;
    }

    function initMapPanFromTouch(touch) {
        const container = document.querySelector(".overview__world--container");
        if (!container || !touch) return false;
        mapPan.startX = touch.clientX;
        mapPan.startScrollLeft = container.scrollLeft;
        mapPan.touchId = touch.identifier;
        mapPan.pointerId = null;
        mapPan.active = false;

        const onMove = function (e) {
            const t = mapPan.touchId != null ? getMapPanTouchById(e, mapPan.touchId) : null;
            const clientX = t ? t.clientX : (e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX);
            const dx = mapPan.startX - clientX;
            if (!mapPan.active) {
                if (Math.abs(dx) < PAN_THRESHOLD) return;
                mapPan.active = true;
            }
            e.preventDefault();
            // const maxScroll = container.scrollWidth - container.clientWidth;
            schedulePanScroll(container, mapPan.startScrollLeft + dx);
        };

        const onEnd = function () {
            document.removeEventListener("touchmove", onMove, { passive: false });
            document.removeEventListener("touchend", onEnd);
            document.removeEventListener("touchcancel", onEnd);
            mapPan.touchId = null;
            mapPan.active = false;
            if (mapPan.rafId != null) {
                cancelAnimationFrame(mapPan.rafId);
                mapPan.rafId = null;
            }
            if (mapPan.pendingScrollLeft != null) {
                applyPanScroll(container);
            }
        };

        document.addEventListener("touchmove", onMove, { passive: false });
        document.addEventListener("touchend", onEnd);
        document.addEventListener("touchcancel", onEnd);
        return true;
    }

    function initializeMapPan() {
        const container = document.querySelector(".overview__world--container");
        if (!container) return;

        const startPan = function (clientX, pointerId) {
            mapPan.startX = clientX;
            mapPan.startScrollLeft = container.scrollLeft;
            mapPan.touchId = null;
            mapPan.pointerId = pointerId != null ? pointerId : null;
            mapPan.active = false;
        };

        const onPointerDown = function (e) {
            if (e.pointerType === "touch") return;
            if (e.target.closest && e.target.closest(".overview__hotspot")) return;
            startPan(e.clientX, e.pointerId);
            mapPan.moveHandler = function (e) {
                if (e.pointerId !== mapPan.pointerId) return;
                const dx = mapPan.startX - e.clientX;
                if (!mapPan.active && Math.abs(dx) < PAN_THRESHOLD) return;
                mapPan.active = true;
                e.preventDefault();
                // const maxScroll = container.scrollWidth - container.clientWidth;
                schedulePanScroll(container, mapPan.startScrollLeft + dx);
            };
            mapPan.endHandler = function (e) {
                if (e.pointerId !== mapPan.pointerId) return;
                document.removeEventListener("pointermove", mapPan.moveHandler, true);
                document.removeEventListener("pointerup", mapPan.endHandler, true);
                document.removeEventListener("pointercancel", mapPan.endHandler, true);
                mapPan.pointerId = null;
                mapPan.active = false;
                if (mapPan.rafId != null) {
                    cancelAnimationFrame(mapPan.rafId);
                    mapPan.rafId = null;
                }
                if (mapPan.pendingScrollLeft != null) {
                    applyPanScroll(container);
                }
            };
            document.addEventListener("pointermove", mapPan.moveHandler, { capture: true, passive: false });
            document.addEventListener("pointerup", mapPan.endHandler, true);
            document.addEventListener("pointercancel", mapPan.endHandler, true);
        };

        const onTouchStart = function (e) {
            if (e.target.closest && e.target.closest(".overview__hotspot")) return;
            if (!e.touches.length) return;
            const touch = e.touches[0];
            startPan(touch.clientX, null);
            mapPan.touchId = touch.identifier;

            mapPan.moveHandler = function (e) {
                const t = getMapPanTouchById(e, mapPan.touchId);
                if (!t) return;
                const dx = mapPan.startX - t.clientX;
                if (!mapPan.active && Math.abs(dx) < PAN_THRESHOLD) return;
                mapPan.active = true;
                e.preventDefault();
                // const maxScroll = container.scrollWidth - container.clientWidth;
                schedulePanScroll(container, mapPan.startScrollLeft + dx);
            };
            mapPan.endHandler = function (e) {
                const changed = e.changedTouches || [];
                let found = false;
                for (let i = 0; i < changed.length; i++) {
                    if (changed[i].identifier === mapPan.touchId) { found = true; break; }
                }
                if (!found && (e.touches && e.touches.length)) return;
                document.removeEventListener("touchmove", mapPan.moveHandler, { passive: false });
                document.removeEventListener("touchend", mapPan.endHandler);
                document.removeEventListener("touchcancel", mapPan.endHandler);
                mapPan.touchId = null;
                mapPan.active = false;
                if (mapPan.rafId != null) {
                    cancelAnimationFrame(mapPan.rafId);
                    mapPan.rafId = null;
                }
                if (mapPan.pendingScrollLeft != null) {
                    applyPanScroll(container);
                }
            };
            document.addEventListener("touchmove", mapPan.moveHandler, { passive: false });
            document.addEventListener("touchend", mapPan.endHandler);
            document.addEventListener("touchcancel", mapPan.endHandler);
        };

        container.addEventListener("pointerdown", onPointerDown, { passive: true });
        container.addEventListener("touchstart", onTouchStart, { passive: true });
    }

    $(document).on("click", ".overview__hotspot", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $hotspot = $(this);
        const status = $hotspot.data("goal-status");
        const goalTitle = $hotspot.data("goal-title");
        
        if (status === "completed") {
            // Show feedback message for all completed hotspots
            $hotspot.addClass("show-feedback");

            setTimeout(() => {
                $hotspot.removeClass("show-feedback");
            }, 2500);
            
            return;
        }
        
        currentGoalId = $hotspot.data("goal-id");

        // Drop anything left over from a previously opened goal so a failed or slow
        // load can never leave another goal's questions on screen.
        currentGoalData = null;
        loadedGoalId = null;
        renderedGoalId = null;
        $elms.questionContainer.empty();
        
        // Render loading state
        renderGoalPopup({
            goal_title: goalTitle,
            goal_description: "Loading...",
            is_loading: true
        });
        
        $elms.goalPopup.attr("data-current-goal-id", currentGoalId);
        
        loadGoalDetails(currentGoalId);
        
        if (status === "not_started") {
            updateLearningGoalProgress(currentGoalId, "in_progress");
            $hotspot.removeClass("not-started").addClass("in-progress");
            $hotspot.data("goal-status", "in_progress");
        }
        
        $elms.page.addClass("is-goal-open");
    });

    function loadGoalDetails(goalId) {
        const questionGroupId = $elms.overviewPage.data("question-group-id");
        const phaseId = $elms.overviewPage.data("phase-id");
        const requestId = ++goalDetailsRequestId;

        const isStale = function () {
            return requestId !== goalDetailsRequestId || goalId !== currentGoalId;
        };
        
        const restUrl = window.CFG.restUrl || '/wp-json/bd/v1';
        const endpoint = `${restUrl}/learning-goals/${goalId}/questions?question_group_id=${questionGroupId}${phaseId ? `&phase_id=${phaseId}` : ""}`;
        
        $.ajax({
            url: endpoint,
            type: "GET",
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', window.CFG.restNonce || window.CFG.nonce);
            },
            success: function (response) {
                if (isStale()) return;

                currentGoalData = response;
                loadedGoalId = goalId;
                
                renderGoalPopup({
                    goal_title: response.goal_title,
                    goal_description: response.goal_description || "",
                    goal_person_image: response.goal_person_image,
                    goal_background_image: response.goal_background_image
                });
            },
            error: function () {
                if (isStale()) return;

                $.ajax({
                    url: window.CFG.ajaxUrl,
                    type: "POST",
                    data: {
                        action: "get_learning_goal_questions",
                        learning_goal_id: goalId,
                        question_group_id: questionGroupId,
                        phase_id: phaseId,
                        nonce: window.CFG.nonce,
                    },
                    success: function (response) {
                        if (isStale()) return;

                        if (response.success) {
                            currentGoalData = response.data;
                            loadedGoalId = goalId;
                            renderGoalPopup({
                                goal_title: response.data.goal_title,
                                goal_description: response.data.goal_description || "",
                                goal_person_image: response.data.goal_person_image,
                                goal_background_image: response.data.goal_background_image
                            });
                        } else {
                            showGoalLoadError();
                        }
                    },
                    error: function () {
                        if (!isStale()) showGoalLoadError();
                    }
                });
            }
        });
    }

    function showGoalLoadError() {
        const person = $elms.goalContainer.find(".overview__goal__person");
        person.removeClass("is-loading").attr("aria-busy", "false");
        person.find("[role=status]").text("Image unavailable");
        $elms.goalContainer.find(".overview__goal__description").text("Unable to load this goal. Please close and try again.");
    }

    $(document).on("click", ".js-goal-start", function () {
        if (!currentGoalData || !currentGoalData.questions) {
            return;
        }

        if (loadedGoalId !== currentGoalId) {
            return;
        }

        renderQuestions(currentGoalData.questions, currentGoalData.saved_answers || {});
        renderedGoalId = currentGoalId;

        $elms.page.removeClass("is-goal-open");
        $elms.page.addClass("is-question-open");
    });

    $(document).on("click", ".overview__goal__close", function () {
        $elms.page.removeClass("is-goal-open");
        currentGoalId = null;
        currentGoalData = null;
        loadedGoalId = null;
    });

    $elms.questionClose.on("click", function () {
        $elms.page.removeClass("is-question-open");
    });

    $(document).on("click", ".js-submit-answers", function () {
        // Submit against the goal whose questions are on screen. currentGoalId can point
        // at a different goal by the time the answers are sent.
        const goalId = renderedGoalId;

        if (!goalId) {
            alert("Error: Learning goal ID is missing. Please try clicking the hotspot again.");
            return;
        }

        const answers = [];
        $elms.questionContainer.find(".js-slider-input").each(function () {
            const $slider = $(this);
            answers.push({
                questionId: $slider.data("question-id"),
                value: parseInt($slider.val())
            });
        });

        if (!answers.length) {
            return;
        }

        const $hotspot = $(`.overview__hotspot[data-goal-id="${goalId}"]`);
        
        $elms.page.removeClass("is-question-open");
        
        updateLearningGoalProgress(goalId, "completed", answers, function(response) {
            if (response.success) {
                const data = response.data;
                
                if (data.points_earned > 0) {
                    $(".js-points-earned-value").text("+" + data.points_earned);
                    $(".overview__points--value").text("+" + data.points_earned);
                    
                    if (data.total_points !== undefined) {
                        $(".js-user-total-points").text(data.total_points);
                    }
                    
                    if (data.badge_url) {
                        const $badgeImg = $(".overview__profile__badge img");
                        $badgeImg.attr("src", data.badge_url);
                        
                        if (data.badge_tier) {
                            $badgeImg.attr("alt", data.badge_tier);
                            $badgeImg.closest(".overview__profile__badge").attr("title", data.badge_tier);
                        }
                    }
                    
                    $elms.page.addClass("is-points-overlay-open");

                    if (data.level_up) {
                        $elms.page.addClass("is-points-levelup-flow");
                        startLevelUpAnimation(data);
                    }
                }
                
                $hotspot.removeClass("in-progress not-started").addClass("completed");
                $hotspot.data("goal-status", "completed");
                
                $(document).trigger("hotspot-status-changed");
                updateProgressCounter();
            } else {
                alert("Failed to save your progress. Please try again.");
            }
        });
    });

    let levelUpAnimationTimer = null;
    let levelupConfettiRafId = null;
    let levelupConfettiStreaming = false;
    let levelupConfettiLastSpawnMs = 0;

    /** Palette aligned with Figma “Confetti 1” (MDT effect measurement) — small flat chips */
    const LEVELUP_CONFETTI_COLORS = ["#ef4444", "#2563eb", "#059669", "#facc15", "#14b8a6"];

    function stopLevelupConfettiStream() {
        levelupConfettiStreaming = false;
        if (levelupConfettiRafId) {
            cancelAnimationFrame(levelupConfettiRafId);
            levelupConfettiRafId = null;
        }
    }

    function clearLevelupConfetti() {
        stopLevelupConfettiStream();
        const root = document.querySelector(".js-levelup-confetti-root");
        if (root) {
            root.innerHTML = "";
        }
    }

    function spawnLevelupConfettiPiece(root) {
        const p = document.createElement("span");
        p.className = "overview__levelup--confetti-piece";
        p.style.left = Math.random() * 100 + "%";
        p.style.top = -8 - Math.random() * 10 + "%";

        const h = root.clientHeight || window.innerHeight || 640;
        const w = root.clientWidth || window.innerWidth || 400;
        const dy = h * (0.92 + Math.random() * 0.28);
        const dx = (Math.random() - 0.5) * Math.min(w * 0.5, 200);
        p.style.setProperty("--confetti-dx", dx + "px");
        p.style.setProperty("--confetti-dy", dy + "px");

        p.style.backgroundColor =
            LEVELUP_CONFETTI_COLORS[Math.floor(Math.random() * LEVELUP_CONFETTI_COLORS.length)];

        const rw = 9 + Math.random() * 6;
        const tall = Math.random() > 0.4;
        p.style.width = rw + "px";
        p.style.height = tall ? rw * (1.15 + Math.random() * 0.45) + "px" : rw * (0.55 + Math.random() * 0.2) + 3 + "px";
        p.style.borderRadius = "2px";

        const dur = 2.35 + Math.random() * 1.85;
        p.style.animationDuration = dur + "s";

        root.appendChild(p);
        window.setTimeout(function () {
            if (p.parentNode === root) {
                root.removeChild(p);
            }
        }, (dur + 0.2) * 1000);
    }

    function tickLevelupConfetti(ts) {
        if (!levelupConfettiStreaming) {
            return;
        }
        const root = document.querySelector(".js-levelup-confetti-root");
        if (
            !root ||
            !$elms.page.hasClass("levelup-phase-4") ||
            !$elms.page.hasClass("is-level-overlay-open")
        ) {
            stopLevelupConfettiStream();
            return;
        }

        if (!levelupConfettiLastSpawnMs) {
            levelupConfettiLastSpawnMs = ts;
        }
        const interval = 48 + Math.random() * 36;
        if (ts - levelupConfettiLastSpawnMs >= interval) {
            levelupConfettiLastSpawnMs = ts;
            const batch = 2 + (Math.random() > 0.5 ? 1 : 0);
            for (let i = 0; i < batch; i++) {
                spawnLevelupConfettiPiece(root);
            }
        }

        while (root.children.length > 150 && root.firstChild) {
            root.removeChild(root.firstChild);
        }

        levelupConfettiRafId = window.requestAnimationFrame(tickLevelupConfetti);
    }

    function startLevelupConfettiStream() {
        if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return;
        }
        const root = document.querySelector(".js-levelup-confetti-root");
        if (!root) {
            return;
        }

        clearLevelupConfetti();
        levelupConfettiStreaming = true;
        levelupConfettiLastSpawnMs = 0;

        for (let i = 0; i < 32; i++) {
            spawnLevelupConfettiPiece(root);
        }

        levelupConfettiRafId = window.requestAnimationFrame(tickLevelupConfetti);
    }

    function startLevelUpAnimation(data) {
        $(".js-levelup-points-label").text("+" + data.points_earned);
        $(".js-levelup-title").text(data.badge_tier + " " + $(".js-levelup-title").data("reached-label"));

        if (data.badge_url) {
            $(".js-levelup-new-badge").attr("src", data.badge_url);
            $(".js-levelup-badge-img").attr("src", data.old_badge_url || data.badge_url);
        }

        clearTimeout(levelUpAnimationTimer);

        levelUpAnimationTimer = setTimeout(function () {
            $elms.page.addClass("is-level-overlay-open");

            setTimeout(function () {
                $elms.page.addClass("levelup-phase-1");
            }, 300);

            setTimeout(function () {
                $elms.page.addClass("levelup-phase-2");
            }, 800);

            setTimeout(function () {
                $elms.page.removeClass("levelup-phase-1 levelup-phase-2");
                $elms.page.addClass("levelup-phase-3");
            }, 2000);

            setTimeout(function () {
                $elms.page.removeClass("levelup-phase-3");
                $elms.page.addClass("levelup-phase-4");
                window.requestAnimationFrame(function () {
                    startLevelupConfettiStream();
                });
            }, 3000);
        }, 2000);
    }

    function resetLevelUpOverlay() {
        clearTimeout(levelUpAnimationTimer);
        clearLevelupConfetti();
        $elms.page.removeClass(
            "is-points-overlay-open is-points-levelup-flow is-level-overlay-open levelup-phase-1 levelup-phase-2 levelup-phase-3 levelup-phase-4"
        );
    }

    $(document).on("click", ".js-close-points-overlay", function () {
        resetLevelUpOverlay();
    });

    $(document).on("click", ".js-close-level-overlay", function () {
        resetLevelUpOverlay();
    });

    $(document).on("click", ".js-continue-to-next", function () {
        const nextUrl = $(this).data("next-url");
        if (nextUrl) {
            window.location.href = nextUrl;
        }
    });

    $elms.profilePicture.on("click", function () {
        // const href = $(this).data("href");
        // if (href) {
        //     window.location.href = href;
        // }

        const hasRole = $elms.profile.data("has-role");
        if (hasRole === false || hasRole === "false") {
            return;
        }

        $elms.page.addClass("is-profile-card-open");
    });

    $elms.profileCardClose.on("click", function () {
        $elms.page.removeClass("is-profile-card-open");
    });

    function updateOverviewSubmitButtonState() {
        const $btn = $elms.questionContainer.find(".js-submit-answers");
        if (!$btn.length) return;
        const $sliders = $elms.questionContainer.find(".js-slider-input");
        const allAnswered = $sliders.length === 0 || $sliders.filter(function () {
            return $(this).attr("is-activated") !== "1";
        }).length === 0;
        $btn.prop("disabled", !allAnswered);
    }

    function renderGoalPopup(goalData) {
        const html = compileTemplate('goal-popup-template', goalData);
        
        if (!html) {
            return;
        }
        
        $elms.goalContainer.html(html);
        if (goalData.is_loading) return;

        const person = $elms.goalContainer.find(".overview__goal__person")[0];
        const goalId = currentGoalId;
        const requestId = goalDetailsRequestId;
        const isCurrent = () => goalId === currentGoalId &&
            requestId === goalDetailsRequestId && person.isConnected;
        const fallback = person.dataset.defaultImage;
        const source = typeof goalData.goal_person_image === "string" ? goalData.goal_person_image.trim() : "";

        function loadImage(url, isFallback = false) {
            const image = new Image();
            image.alt = "";
            const failed = () => {
                if (!isCurrent()) return;
                if (!isFallback) {
                    loadImage(fallback, true);
                } else {
                    person.classList.remove("is-loading");
                    person.setAttribute("aria-busy", "false");
                    person.querySelector("[role=status]").textContent = "Image unavailable";
                }
            };
            image.onerror = failed;
            image.onload = async () => {
                if (!isCurrent()) return;
                try {
                    if (typeof image.decode === "function") await image.decode();
                } catch {
                    failed();
                    return;
                }
                if (!isCurrent()) return;
                person.replaceChildren(image);
                person.classList.remove("is-loading");
                person.setAttribute("aria-busy", "false");
            };
            image.src = url;
        }

        loadImage(source || fallback, !source || source === fallback);
    }

    /* eslint-disable-next-line no-unused-vars */
    function renderQuestions(questions, savedAnswers = {}) {

        const questionsWithDefaults = questions.map((question, index) => {
            // disable saved answer as default value based on change request: https://app.clickup.com/t/86c98v689
            const savedValue = 0; //savedAnswers[question.ID] || 0;
            const sliderIcon = (question.slider_icon && typeof question.slider_icon === 'string' && question.slider_icon.trim() !== '')
                ? question.slider_icon
                : null;
            return {
                ...question,
                questionNumber: index + 1,
                slider_icon: sliderIcon,
                slider_gradient_color_left: question.slider_gradient_color_left || '#90e090',
                slider_gradient_color_right: question.slider_gradient_color_right || '#f5b04c',
                saved_value: savedValue
            };
        });

        const html = compileTemplate('question-popup-template', { questions: questionsWithDefaults });
        
        if (!html) {
            return;
        }
        
        $elms.questionContainer.html(html);

        // disable saved answer as default value based on change request: https://app.clickup.com/t/86c98v689
        initializeSliders({}); //savedAnswers);
        updateOverviewSubmitButtonState();
    }

    function updateLearningGoalProgress(goalId, status, questionsAnswered = null, callback = null) {
        const questionGroupId = $elms.overviewPage.data("question-group-id");
        const phaseId = $elms.overviewPage.data("phase-id") || null;
        
        if (!goalId || goalId === 0) {
            if (callback) {
                callback({ success: false, data: { message: "Invalid goal ID" } });
            }
            return;
        }
        
        const restUrl = window.CFG.restUrl || '/wp-json/bd/v1';
        const endpoint = `${restUrl}/learning-goals/${goalId}/progress`;
        
        $.ajax({
            url: endpoint,
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({
                status: status,
                questions_answered: questionsAnswered,
                question_group_id: questionGroupId,
                phase_id: phaseId,
            }),
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', window.CFG.restNonce || window.CFG.nonce);
            },
            success: function (response) {
                const data = response;
                const maxPoints = data.max_experience_points || parseInt($elms.overviewPage.data("max-experience-points")) || 1000;
                const totalPoints = data.total_points || 0;
                const experiencePercentage = Math.min(100, Math.round((totalPoints / maxPoints) * 100));
                
                $elms.profileExpInner.css("width", experiencePercentage + "%");

                if (data.qg_mandatory_completed) {
                    $(".overview").addClass("is-finished");
                }
                
                if (callback && typeof callback === 'function') {
                    callback({ success: true, data: data });
                }
            },
            error: function (xhr) {
                const errorMessage = xhr.responseJSON?.message || "Failed to update progress. Please try again.";
                alert(errorMessage);
                
                $.ajax({
                    url: window.CFG.ajaxUrl,
                    type: "POST",
                    data: {
                        action: "update_learning_goal_progress",
                        learning_goal_id: goalId,
                        status: status,
                        questions_answered: questionsAnswered,
                        question_group_id: questionGroupId,
                        phase_id: phaseId,
                        nonce: window.CFG.nonce,
                    },
                    success: function (response) {
                        if (response.success) {
                            const maxPoints = response.data.max_experience_points || parseInt($elms.overviewPage.data("max-experience-points")) || 1000;
                            const totalPoints = response.data.total_points || 0;
                            const experiencePercentage = Math.min(100, Math.round((totalPoints / maxPoints) * 100));
                            
                            $elms.profileExpInner.css("width", experiencePercentage + "%");

                            if (response.data.qg_mandatory_completed) {

                                setTimeout(() => {
                                    $(".overview").addClass("is-finished");
                                }, 1500);
                            }
                            
                            if (callback && typeof callback === 'function') {
                                callback(response);
                            }
                        }
                    }
                });
            }
        });
    }

    function updateProgressCounter() {
        if (!$elms.progressCounter.length) return;
        
        let completedCount = 0;
        let totalCount = 0;
        
        const $mandatoryHotspots = $elms.hotspot.filter('.mandatory');
        const $hotspotsToCount = $mandatoryHotspots.length > 0 ? $mandatoryHotspots : $elms.hotspot;
        
        totalCount = $hotspotsToCount.length;
        completedCount = $hotspotsToCount.filter('.completed').length;
        
        $elms.completedCount.text(completedCount);
        $elms.totalCount.text(totalCount);
        
        $elms.progressCounter.attr('data-completed', completedCount);
        $elms.progressCounter.attr('data-total', totalCount);
        
        if (completedCount === totalCount && totalCount > 0) {
            $elms.page.addClass("is-finished");
        }
    }

    function initializeSliders(savedAnswers = {}) {
        const sliders = document.querySelectorAll(".slider");

        function colorToRGB(color) {
            const temp = document.createElement("div");
            temp.style.color = color;
            document.body.appendChild(temp);
            const computedColor = window.getComputedStyle(temp).color;
            document.body.removeChild(temp);

            const rgb = computedColor.match(/\d+/g).map(Number);
            return rgb;
        }

        sliders.forEach((sliderContainer) => {
            const sliderInput = sliderContainer.querySelector(".slider__input");
            const valueDisplay = sliderContainer.querySelector(".slider__value-display");
            const customThumb = sliderContainer.querySelector(".slider__thumb");
            const thumbIcon = sliderContainer.querySelector(".slider__thumb svg, .slider__thumb img");

            const questionId = sliderInput.dataset.questionId;
            const savedValue = savedAnswers[questionId] || 0;
            let hasBeenActivated = savedValue > 0;
            
            if (savedValue > 0) {
                sliderInput.value = savedValue;
                sliderInput.setAttribute("is-activated", "1");
            }

            function updateSlider(value) {
                const min = parseFloat(sliderInput.min);
                const max = parseFloat(sliderInput.max);

                valueDisplay.textContent = value;

                const percent = ((value - min) / (max - min)) * 100;

                const minThumbSize = 2;
                const maxThumbSize = 3.125;
                const thumbSize = minThumbSize + (percent / 100) * (maxThumbSize - minThumbSize);
                customThumb.style.width = `${thumbSize}em`;
                customThumb.style.height = `${thumbSize}em`;

                customThumb.style.left = `calc(${percent}% - ${thumbSize * (percent / 100 - 0.5)}em)`;

                if (value > 0) {
                    hasBeenActivated = true;
                    sliderInput.setAttribute("is-activated", "1");
                }

                if (typeof updateOverviewSubmitButtonState === "function") {
                    updateOverviewSubmitButtonState();
                }

                if (hasBeenActivated || value > 0) {
                    const track = sliderContainer.querySelector(".slider__track");
                    const gradientLeft = track.getAttribute("data-gradient-left");
                    const gradientRight = track.getAttribute("data-gradient-right");
                    
                    const startColor = colorToRGB(gradientLeft);
                    const endColor = colorToRGB(gradientRight);
                    const color = startColor.map((start, i) => {
                        const end = endColor[i];
                        return Math.round(start + (end - start) * (percent / 100));
                    });

                    thumbIcon.style.opacity = value <= 3 ? "0" : "1";

                    valueDisplay.style.color = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
                    customThumb.style.backgroundColor = 'rgb(144, 224, 144)';
                    track.style.background = `#f17f3c`;
                } else {
                    const track = sliderContainer.querySelector(".slider__track");
                    track.style.background = "#cccccc";
                    if (thumbIcon) {
                        thumbIcon.style.opacity = "0";
                    }
                    valueDisplay.style.color = "#999999";
                    customThumb.style.backgroundColor = "#999999";
                }
            }

            sliderInput.addEventListener("input", (event) => {
                updateSlider(event.target.value);
            });

            const handlers = {
                isDragging: false,
                
                onMouseMove: (event) => {
                    if (!handlers.isDragging) return;
                    event.preventDefault();

                    const sliderRect = sliderContainer.querySelector(".slider__wrapper").getBoundingClientRect();
                    const clientX = event.clientX;
                    const percent = Math.max(0, Math.min(100, ((clientX - sliderRect.left) / sliderRect.width) * 100));

                    const min = parseFloat(sliderInput.min);
                    const max = parseFloat(sliderInput.max);
                    const value = Math.round(min + (percent / 100) * (max - min));

                    sliderInput.value = value;
                    updateSlider(value);

                    const inputEvent = new Event("input", { bubbles: true });
                    sliderInput.dispatchEvent(inputEvent);
                },
                
                onMouseUp: () => {
                    handlers.isDragging = false;
                    document.removeEventListener("mousemove", handlers.onMouseMove);
                    document.removeEventListener("mouseup", handlers.onMouseUp);
                },
                
                onTouchMove: (event) => {
                    if (!handlers.isDragging) return;
                    event.preventDefault();

                    const sliderRect = sliderContainer.querySelector(".slider__wrapper").getBoundingClientRect();
                    const clientX = event.touches[0].clientX;
                    const percent = Math.max(0, Math.min(100, ((clientX - sliderRect.left) / sliderRect.width) * 100));

                    const min = parseFloat(sliderInput.min);
                    const max = parseFloat(sliderInput.max);
                    const value = Math.round(min + (percent / 100) * (max - min));

                    sliderInput.value = value;
                    updateSlider(value);

                    const inputEvent = new Event("input", { bubbles: true });
                    sliderInput.dispatchEvent(inputEvent);
                },
                
                onTouchEnd: () => {
                    handlers.isDragging = false;
                    document.removeEventListener("touchmove", handlers.onTouchMove);
                    document.removeEventListener("touchend", handlers.onTouchEnd);
                }
            };

            customThumb.addEventListener("mousedown", (event) => {
				if (sliderInput.disabled) return;

				handlers.isDragging = true;
				event.preventDefault();
				
				document.addEventListener("mousemove", handlers.onMouseMove);
				document.addEventListener("mouseup", handlers.onMouseUp);
			});

			customThumb.addEventListener("touchstart", (event) => {
				if (sliderInput.disabled) return;

				handlers.isDragging = true;
				event.preventDefault();
				
				document.addEventListener("touchmove", handlers.onTouchMove, {
					passive: false,
				});
				document.addEventListener("touchend", handlers.onTouchEnd);
			});

            const sliderWrapper = sliderContainer.querySelector(".slider__wrapper");
			sliderWrapper.addEventListener("click", (event) => {
				if (sliderInput.disabled) return;

				if (event.target === customThumb || customThumb.contains(event.target))
					return;

				const sliderRect = sliderWrapper.getBoundingClientRect();
				const percent = Math.max(
					0,
					Math.min(
						100,
						((event.clientX - sliderRect.left) / sliderRect.width) * 100,
					),
				);

				const min = parseFloat(sliderInput.min);
				const max = parseFloat(sliderInput.max);
				const value = Math.round(min + (percent / 100) * (max - min));

				sliderInput.value = value;
				updateSlider(value);

				const inputEvent = new Event("input", { bubbles: true });
				sliderInput.dispatchEvent(inputEvent);
			});

			updateSlider(sliderInput.value);
        });
    }

    function initializeIndicators() {
        const $worldContainer = $(".overview__world--container");
        const $indicatorLeft = $(".overview__indicator.indicator-left");
        const $indicatorRight = $(".overview__indicator.indicator-right");
        
        if (!$worldContainer.length || !$indicatorLeft.length || !$indicatorRight.length) {
            return;
        }

        function updateIndicators() {
            const containerRect = $worldContainer[0].getBoundingClientRect();
            const containerLeft = containerRect.left;
            const containerRight = containerRect.right;

            const $mandatoryHotspots = $(".overview__hotspot.mandatory:not(.completed)");
            
            if ($mandatoryHotspots.length === 0) {
                $indicatorLeft.addClass("hidden");
                $indicatorRight.addClass("hidden");
                return;
            }

            let hasHiddenLeft = false;
            let hasHiddenRight = false;

            $mandatoryHotspots.each(function() {
                const hotspotRect = $(this)[0].getBoundingClientRect();
                const hotspotCenterX = hotspotRect.left + (hotspotRect.width / 2);

                if (hotspotCenterX < containerLeft) {
                    hasHiddenLeft = true;
                }
                
                if (hotspotCenterX > containerRight) {
                    hasHiddenRight = true;
                }
            });

            if (hasHiddenLeft) {
                $indicatorLeft.removeClass("hidden");
            } else {
                $indicatorLeft.addClass("hidden");
            }

            if (hasHiddenRight) {
                $indicatorRight.removeClass("hidden");
            } else {
                $indicatorRight.addClass("hidden");
            }
        }

        updateIndicators();

        $worldContainer.on("scroll", updateIndicators);
        $(document).on("hotspot-status-changed", updateIndicators);
        $(window).on("resize", updateIndicators);
    }

    initializeSliders();
    initializeIndicators();
    initializeMapPan();

    // Initialize progress counter on page load
    updateProgressCounter();
}